<template>
  <div class="property-panel">
    <div class="prop-header"><i class="fas fa-sliders-h"></i><span>属性面板</span></div>
    <div class="prop-body" v-if="control">
      <!-- 标识 -->
      <div class="prop-section" v-if="hasFieldId">
        <div class="prop-section-title">标识</div>
        <div class="prop-row"><label>字段ID</label><input v-model="control.props.fieldId" @input="save" class="prop-input" /></div>
        <div class="prop-row"><label>字段名</label><input v-model="control.props.fieldName" @input="save" class="prop-input" /></div>
        <div class="prop-row"><label>CSS类</label><input v-model="control.props.className" @input="save" class="prop-input" /></div>
      </div>

      <!-- 基本 -->
      <div class="prop-section" v-if="hasBase">
        <div class="prop-section-title">基本</div>
        <!-- Button 专属属性 -->
        <template v-if="control.type === 'Button'">
          <div class="prop-row" v-if="'text' in control.props">
            <label>文字</label><input v-model="control.props.text" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'type' in control.props">
            <label>尺寸</label>
            <select v-model="control.props.type" @change="save" class="prop-select">
              <option value="default">默认</option>
              <option value="primary">主要</option>
              <option value="success">成功</option>
              <option value="warning">警告</option>
              <option value="danger">危险</option>
            </select>
          </div>
          <div class="prop-row" v-if="'size' in control.props">
            <label>大小</label>
            <select v-model="control.props.size" @change="save" class="prop-select">
              <option value="small">小</option>
              <option value="medium">中</option>
              <option value="large">大</option>
            </select>
          </div>
          <div class="prop-row">
            <label>按钮颜色</label>
            <div style="display:flex;gap:4px;align-items:center;">
              <input type="color" v-model="control.props.buttonColor" @input="save" class="prop-color" style="width:36px;height:28px;padding:1px;border:1px solid #ccc;border-radius:3px;cursor:pointer;" />
              <input v-model="control.props.buttonColor" @input="save" class="prop-input" placeholder="#1ab394" style="flex:1;min-width:0;" />
              <button v-if="control.props.buttonColor" @click="control.props.buttonColor='';save()" style="padding:2px 8px;font-size:12px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;color:#666;">清除</button>
            </div>
          </div>
          <div class="prop-row">
            <label>文字颜色</label>
            <div style="display:flex;gap:4px;align-items:center;">
              <input type="color" v-model="control.props.textColor" @input="save" class="prop-color" style="width:36px;height:28px;padding:1px;border:1px solid #ccc;border-radius:3px;cursor:pointer;" />
              <input v-model="control.props.textColor" @input="save" class="prop-input" placeholder="#ffffff" style="flex:1;min-width:0;" />
              <button v-if="control.props.textColor" @click="control.props.textColor='';save()" style="padding:2px 8px;font-size:12px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;color:#666;">清除</button>
            </div>
          </div>
        </template>
        <!-- 其他控件类型的属性 -->
        <template v-else>
          <div class="prop-row" v-if="'label' in control.props && control.type !== 'Label' && control.type !== 'HyperLink'">
            <label>标签</label><input v-model="control.props.label" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'label' in control.props && control.type !== 'Label' && control.type !== 'HyperLink'">
            <label>标签颜色</label>
            <div style="display:flex;gap:4px;align-items:center;">
              <input type="color" v-model="control.props.labelColor" @input="save" class="prop-color" style="width:36px;height:28px;padding:1px;border:1px solid #ccc;border-radius:3px;cursor:pointer;" />
              <input v-model="control.props.labelColor" @input="save" class="prop-input" placeholder="#333333" style="flex:1;min-width:0;" />
              <button v-if="control.props.labelColor" @click="control.props.labelColor='';save()" style="padding:2px 8px;font-size:12px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;color:#666;">清除</button>
            </div>
          </div>
          <div class="prop-row" v-if="'label' in control.props && control.type !== 'Label' && control.type !== 'HyperLink'">
            <label>标签加粗</label><label class="prop-switch"><input type="checkbox" v-model="control.props.labelBold" @change="save" /><span class="slider"></span></label>
          </div>
          <div class="prop-row" v-if="'placeholder' in control.props">
            <label>占位</label><input v-model="control.props.placeholder" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'content' in control.props">
            <label>文本</label><input v-model="control.props.content" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'startPlaceholder' in control.props">
            <label>开始占位</label><input v-model="control.props.startPlaceholder" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'endPlaceholder' in control.props">
            <label>结束占位</label><input v-model="control.props.endPlaceholder" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'options' in control.props && !isTableType">
            <label>选项</label><input v-model="control.props.options" @input="save" class="prop-input" placeholder="逗号分隔" />
          </div>
          <div class="prop-row" v-if="'href' in control.props">
            <label>链接</label><input v-model="control.props.href" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'text' in control.props && control.type !== 'Button'">
            <label>文字</label><input v-model="control.props.text" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'prefix' in control.props">
            <label>前缀</label><input v-model="control.props.prefix" @input="save" class="prop-input" />
          </div>
          <div class="prop-row" v-if="'length' in control.props">
            <label>长度</label><input v-model.number="control.props.length" @input="save" class="prop-input" type="number" />
          </div>
          <div class="prop-row" v-if="'title' in control.props">
            <label>标题</label><input v-model="control.props.title" @input="save" class="prop-input" />
          </div>
        </template>
      </div>

      <!-- 数据绑定 -->
      <div class="prop-section" v-if="hasDataBinding && control.type !== 'Label'">
        <div class="prop-section-title">数据绑定</div>
        <!-- 数据源：表下拉 + 字段下拉 -->
        <div class="prop-row full">
          <label>数据源</label>
          <div class="bind-pair">
            <select :value="control.props.dataSourceTable || ''" @change="onSrcTableChange" class="prop-select">
              <option value="">-- 选择表 --</option>
              <option v-for="t in boundTables" :key="t.guid || t.Guid" :value="t.tableName || t.TableName">{{ t.tableName || t.TableName }}</option>
            </select>
            <select :value="control.props.dataSourceField || ''" @change="onSrcFieldChange" class="prop-select">
              <option value="">-- 选择字段 --</option>
              <option v-for="col in srcColumns" :key="col.columnName || col.ColumnName" :value="col.columnName || col.ColumnName">{{ col.columnName || col.ColumnName }}</option>
            </select>
          </div>
        </div>
        <!-- 数据目标：表下拉 + 字段下拉 -->
        <div class="prop-row full" v-if="control.type !== 'HyperLink'">
          <label>数据目标</label>
          <div class="bind-pair">
            <select :value="control.props.dataTargetTable || ''" @change="onTgtTableChange" class="prop-select">
              <option value="">-- 选择表 --</option>
              <option v-for="t in boundTables" :key="t.guid || t.Guid" :value="t.tableName || t.TableName">{{ t.tableName || t.TableName }}</option>
            </select>
            <select :value="control.props.dataTargetField || ''" @change="onTgtFieldChange" class="prop-select">
              <option value="">-- 选择字段 --</option>
              <option v-for="col in tgtColumns" :key="col.columnName || col.ColumnName" :value="col.columnName || col.ColumnName">{{ col.columnName || col.ColumnName }}</option>
            </select>
          </div>
        </div>
        <div class="prop-row" v-if="'defaultValue' in control.props && control.type !== 'DateRange' && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'RichText' && control.type !== 'SerialNumber' && control.type !== 'TreeSelect'">
          <label>默认值</label>
          <div style="display:flex;gap:4px;align-items:center;">
            <input v-model="control.props.defaultValue" @input="save" class="prop-input" style="flex:1;min-width:0;" placeholder="手动输入或选择系统变量" />
            <select v-model="control.props.defaultValueSysVar" @change="onSysVarChange" class="prop-select" style="flex:0 0 auto;min-width:120px;">
              <option value="">系统变量</option>
              <option value="syscurrentdatetime">当前日期时间</option>
              <option value="syscurrenttime">当前时间</option>
              <option value="systoday">今天日期</option>
              <option value="systaskid">任务ID</option>
              <option value="sysloginuser.account">登录账号</option>
              <option value="sysloginuser.displayname">显示名称</option>
              <option value="sysloginuser.email">邮箱</option>
              <option value="sysloginuser.tel">电话</option>
              <option value="sysloginuser.mb">手机</option>
              <option value="sysloginuser.hrid">人员ID</option>
              <option value="sysloginuser.job">岗位</option>
              <option value="sysloginuser.office">办公室</option>
              <option value="sysloginuser.costcenter">成本中心</option>
              <option value="sysloginuser.levels">级别</option>
              <option value="sysloginuser.description">描述</option>
              <option value="sysloginuser.birthday">生日</option>
              <option value="sysloginuser.joindate">入职日期</option>
              <option value="sysloginuser.qq">QQ</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 布局 -->
      <div class="prop-section" v-if="'colSpan' in control.props">
        <div class="prop-section-title">布局</div>
        <div class="prop-row">
          <label>列宽</label>
          <div class="colspan-bar">
            <button v-for="n in [3,4,6,8,12]" :key="n" class="cs-btn" :class="{ active: (control.props.colSpan || 12) === n }" @click="control.props.colSpan = n; save()">{{ n === 12 ? '整行' : n }}</button>
          </div>
        </div>
        <div class="prop-row">
          <label>排序号</label><input v-model.number="control.props.sortOrder" @input="save" class="prop-input" type="number" />
        </div>
      </div>

      <!-- 尺寸 -->
      <div class="prop-section" v-if="hasSizeProps && control.type !== 'Label'">
        <div class="prop-section-title">尺寸</div>
        <div class="prop-row" v-if="'width' in control.props">
          <label>宽度</label><input v-model.number="control.props.width" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'height' in control.props">
          <label>高度</label><input v-model.number="control.props.height" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'rows' in control.props">
          <label>行数</label><input v-model.number="control.props.rows" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'padding' in control.props">
          <label>内边距</label><input v-model.number="control.props.padding" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'gap' in control.props">
          <label>间距</label><input v-model.number="control.props.gap" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'fontSize' in control.props">
          <label>字号</label><input v-model.number="control.props.fontSize" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'fileMaxSize' in control.props">
          <label>文件限制</label><input v-model.number="control.props.fileMaxSize" @input="save" class="prop-input" type="number" /><span class="unit">MB</span>
        </div>
        <div class="prop-row" v-if="'fileMaxCount' in control.props">
          <label>最大数量</label><input v-model.number="control.props.fileMaxCount" @input="save" class="prop-input" type="number" />
        </div>
      </div>

      <!-- 数字 -->
      <div class="prop-section" v-if="hasNumberProps">
        <div class="prop-section-title">数字</div>
        <div class="prop-row" v-if="'min' in control.props">
          <label>最小值</label><input v-model="control.props.min" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'max' in control.props">
          <label>最大值</label><input v-model="control.props.max" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'decimal' in control.props">
          <label>小数位</label><input v-model.number="control.props.decimal" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row" v-if="'separator' in control.props">
          <label>千分位</label><label class="prop-switch"><input type="checkbox" v-model="control.props.separator" @change="save" /><span class="slider"></span></label>
        </div>
      </div>

      <!-- 校验 -->
      <div class="prop-section" v-if="hasValidate && control.type !== 'Label'">
        <div class="prop-section-title">校验</div>
        <div class="prop-row" v-if="'required' in control.props && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'SerialNumber'">
          <label>必填</label><label class="prop-switch"><input type="checkbox" v-model="control.props.required" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'maxLength' in control.props && control.type !== 'InputNumber' && control.type !== 'DateRange' && control.type !== 'DatePicker' && control.type !== 'TimePicker' && control.type !== 'Radio' && control.type !== 'Checkbox' && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'SerialNumber' && control.type !== 'Select' && control.type !== 'TreeSelect'">
          <label>最大长度</label><input v-model.number="control.props.maxLength" @input="save" class="prop-input" type="number" /><span v-if="control.props._maxLengthAuto" class="auto-hint" title="从数据库字段自动匹配">auto</span>
        </div>
        <div class="prop-row" v-if="'minLength' in control.props && !isTextType && control.type !== 'InputNumber' && control.type !== 'DateRange' && control.type !== 'DatePicker' && control.type !== 'TimePicker' && control.type !== 'Radio' && control.type !== 'Checkbox' && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'RichText' && control.type !== 'SerialNumber' && control.type !== 'Select' && control.type !== 'TreeSelect'">
          <label>最小长度</label><input v-model.number="control.props.minLength" @input="save" class="prop-input" type="number" />
        </div>
        <div class="prop-row full" v-if="'regex' in control.props && !isTextType && control.type !== 'InputNumber' && control.type !== 'DateRange' && control.type !== 'DatePicker' && control.type !== 'TimePicker' && control.type !== 'Radio' && control.type !== 'Checkbox' && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'RichText' && control.type !== 'SerialNumber' && control.type !== 'Select' && control.type !== 'TreeSelect'">
          <label>正则</label><textarea v-model="control.props.regex" @input="save" class="prop-input" rows="2" placeholder="正则表达式"></textarea>
        </div>
        <div class="prop-row" v-if="'regexMsg' in control.props && !isTextType && control.type !== 'InputNumber' && control.type !== 'DateRange' && control.type !== 'DatePicker' && control.type !== 'TimePicker' && control.type !== 'Radio' && control.type !== 'Checkbox' && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'RichText' && control.type !== 'SerialNumber' && control.type !== 'Select' && control.type !== 'TreeSelect'">
          <label>校验提示</label><input v-model="control.props.regexMsg" @input="save" class="prop-input" />
        </div>
        <div class="prop-row" v-if="'neg' in control.props"><label>不可为负</label><label class="prop-switch"><input type="checkbox" v-model="control.props.neg" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row" v-if="'notZero' in control.props"><label>不可为零</label><label class="prop-switch"><input type="checkbox" v-model="control.props.notZero" @change="save" /><span class="slider"></span></label></div>
      </div>

      <!-- 状态 -->
      <div class="prop-section" v-if="hasStatus && control.type !== 'Label'">
        <div class="prop-section-title">状态</div>
        <div class="prop-row" v-if="'readonly' in control.props && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'SerialNumber'">
          <label>只读</label><label class="prop-switch"><input type="checkbox" v-model="control.props.readonly" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'disabled' in control.props && control.type !== 'HyperLink' && control.type !== 'FileUpload' && control.type !== 'ImageUpload' && control.type !== 'SerialNumber'">
          <label>禁用</label><label class="prop-switch"><input type="checkbox" v-model="control.props.disabled" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'hidden' in control.props && control.type !== 'SerialNumber'">
          <label>隐藏</label><label class="prop-switch"><input type="checkbox" v-model="control.props.hidden" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'printHide' in control.props && control.type !== 'SerialNumber'">
          <label>打印隐藏</label><label class="prop-switch"><input type="checkbox" v-model="control.props.printHide" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'multiple' in control.props">
          <label>多选</label><label class="prop-switch"><input type="checkbox" v-model="control.props.multiple" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'nodownload' in control.props">
          <label>不可下载</label><label class="prop-switch"><input type="checkbox" v-model="control.props.nodownload" @change="save" /><span class="slider"></span></label>
        </div>
      </div>

      <!-- 子表列配置 -->
      <div class="prop-section" v-if="hasSubTableProps">
        <div class="prop-section-title">子表</div>
        <div class="prop-row"><label>表头行</label><input v-model.number="control.props.headRows" @input="save" class="prop-input" type="number" /></div>
        <div class="prop-row"><label>初始行</label><input v-model.number="control.props.initRows" @input="save" class="prop-input" type="number" /></div>
        <div class="prop-row"><label>增加行</label><input v-model.number="control.props.addRows" @input="save" class="prop-input" type="number" /></div>
        <div class="prop-row"><label>表尾行</label><input v-model.number="control.props.footerRows" @input="save" class="prop-input" type="number" /></div>
        <div class="prop-row full">
          <label>绑定表</label>
          <div style="display:flex;gap:4px;flex:1;">
            <input v-model="control.props.formbindtable" @input="onSubTableBindTableChange" list="subTableTableList" class="prop-input" placeholder="数据库表名（小写）" />
            <datalist id="subTableTableList"><option v-for="t in tableNames" :key="t" :value="t" /></datalist>
          </div>
        </div>
      </div>

      <!-- 子表列编辑 -->
      <div class="prop-section" v-if="hasSubTableCols">
        <div class="prop-section-title" style="display:flex;align-items:center;justify-content:space-between;">
          <span>子表列</span>
          <div style="display:flex;gap:4px;">
            <button class="col-add-btn" @click="addSubColumn" title="新增列"><i class="fas fa-plus"></i></button>
            <button class="col-add-btn" @click="addOperationColumn" title="新增操作列" style="background:#f59e0b;"><i class="fas fa-cogs"></i></button>
          </div>
        </div>
        <div v-if="!control.props.columns || control.props.columns.length === 0" class="col-empty">暂无列，点击上方按钮添加</div>
        <div class="col-list">
          <div v-for="(col, ci) in (control.props.columns || [])" :key="ci" class="col-item" :class="{ active: selectedColIndex === ci }" @click="selectedColIndex = ci">
            <span class="col-name">{{ col.props?.label || col.type || '未命名列' }}</span>
            <span class="col-type-tag">{{ col.type === '_operation' ? '操作' : (col.type || 'Input') }}</span>
            <button class="col-del-btn" @click.stop="removeSubColumn(ci)" title="删除列"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <!-- 选中列的编辑 -->
        <div v-if="selectedColIndex >= 0 && selectedColIndex < (control.props.columns || []).length" class="col-edit">
          <!-- 操作列特殊处理 -->
          <template v-if="control.props.columns[selectedColIndex].type === '_operation'">
            <div class="prop-row"><label>列标题</label><input v-model="control.props.columns[selectedColIndex].props.label" @input="save" class="prop-input" /></div>
            <div class="prop-row"><label>列宽(px)</label><input v-model.number="control.props.columns[selectedColIndex].props.width" @input="save" class="prop-input" type="number" min="60" placeholder="留空自适应" /></div>
            <div class="prop-row"><label>操作按钮</label>
              <select v-model="control.props.columns[selectedColIndex].props.operationType" @change="save" class="prop-select">
                <option value="add">新增行</option>
                <option value="delete">删除行</option>
                <option value="add-delete">新增+删除</option>
              </select>
            </div>
          </template>
          <!-- 普通列 -->
          <template v-else>
            <div class="prop-row"><label>列类型</label>
              <select v-model="control.props.columns[selectedColIndex].type" @change="save" class="prop-select">
                <option value="Input">文本框</option>
                <option value="InputNumber">数字</option>
                <option value="Money">金额</option>
                <option value="DatePicker">日期</option>
                <option value="TimePicker">时间</option>
                <option value="Select">下拉框</option>
                <option value="Radio">单选</option>
                <option value="Checkbox">复选</option>
                <option value="Switch">开关</option>
                <option value="Label">文本</option>
                <option value="Textarea">多行文本</option>
              </select>
            </div>
            <div class="prop-row"><label>列标题</label><input v-model="control.props.columns[selectedColIndex].props.label" @input="save" class="prop-input" /></div>
            <div class="prop-row"><label>列宽(px)</label><input v-model.number="control.props.columns[selectedColIndex].props.width" @input="save" class="prop-input" type="number" min="60" placeholder="留空自适应" /></div>
            <div class="prop-row full">
              <label>绑定表</label>
              <div style="display:flex;gap:4px;flex:1;">
                <input v-model="control.props.columns[selectedColIndex].props.bindTable" @input="onSubColBindTableChange(selectedColIndex)" list="subColTableList" class="prop-input" placeholder="留空用子表绑定表" />
                <datalist id="subColTableList"><option v-for="t in tableNames" :key="t" :value="t" /></datalist>
              </div>
            </div>
            <div class="prop-row full">
              <label>绑定字段</label>
              <div style="display:flex;gap:4px;flex:1;">
                <input v-model="control.props.columns[selectedColIndex].props.dataSourceField" @input="save" :list="'subColFieldList_' + selectedColIndex" class="prop-input" placeholder="字段名" />
                <datalist :id="'subColFieldList_' + selectedColIndex"><option v-for="f in (subColColumnsMap[selectedColIndex] || [])" :key="f" :value="f" /></datalist>
              </div>
            </div>
            <div class="prop-row"><label>占位提示</label><input v-model="control.props.columns[selectedColIndex].props.placeholder" @input="save" class="prop-input" /></div>
            <div class="prop-row"><label>默认值</label><input v-model="control.props.columns[selectedColIndex].props.defaultValue" @input="save" class="prop-input" /></div>
            <div class="prop-row"><label>必填</label><label class="prop-switch"><input type="checkbox" v-model="control.props.columns[selectedColIndex].props.required" @change="save" /><span class="slider"></span></label></div>
            <div class="prop-row"><label>只读</label><label class="prop-switch"><input type="checkbox" v-model="control.props.columns[selectedColIndex].props.readonly" @change="save" /><span class="slider"></span></label></div>
            <div class="prop-row" v-if="control.props.columns[selectedColIndex].type === 'Select' || control.props.columns[selectedColIndex].type === 'Radio' || control.props.columns[selectedColIndex].type === 'Checkbox'">
              <label>选项</label><input v-model="control.props.columns[selectedColIndex].props.options" @input="save" class="prop-input" placeholder="逗号分隔" />
            </div>
            <div class="prop-row" v-if="control.props.columns[selectedColIndex].type === 'Input'">
              <label>最大长度</label><input v-model.number="control.props.columns[selectedColIndex].props.maxLength" @input="save" class="prop-input" type="number" />
            </div>

            <!-- 多级表头设置 -->
            <div class="col-sep">多级表头</div>
            <div class="prop-row"><label>表头层级</label>
              <select v-model.number="control.props.columns[selectedColIndex].props.headerLevel" @change="save" class="prop-select">
                <option :value="1">第1级</option>
                <option :value="2">第2级</option>
                <option :value="3">第3级</option>
              </select>
            </div>
            <div class="prop-row"><label>所属分组</label>
              <input v-model="control.props.columns[selectedColIndex].props.headerGroup" @input="save" class="prop-input" placeholder="如：一级/二级，留空则不分组" />
            </div>

            <!-- 尾行设置 -->
            <div class="col-sep">尾行</div>
            <div class="prop-row"><label>尾行类型</label>
              <select v-model="control.props.columns[selectedColIndex].props.footerType" @change="save" class="prop-select">
                <option value="">无</option>
                <option value="sum">合计(SUM)</option>
                <option value="avg">平均(AVG)</option>
                <option value="count">计数(COUNT)</option>
                <option value="text">静态文本</option>
                <option value="button">按钮</option>
              </select>
            </div>
            <div class="prop-row" v-if="control.props.columns[selectedColIndex].props.footerType === 'text' || control.props.columns[selectedColIndex].props.footerType === 'button'">
              <label>尾行文字</label><input v-model="control.props.columns[selectedColIndex].props.footerText" @input="save" class="prop-input" placeholder="按钮文字或文本内容" />
            </div>
            <div class="prop-row" v-if="control.props.columns[selectedColIndex].props.footerType === 'button'">
              <label>按钮类型</label>
              <select v-model="control.props.columns[selectedColIndex].props.buttontype" @change="save" class="prop-select">
                <option value="Add">新增</option>
                <option value="Delete">删除</option>
                <option value="MoveUp">上移</option>
                <option value="MoveDown">下移</option>
                <option value="Browse">浏览</option>
                <option value="">自定义</option>
              </select>
            </div>
          </template>
        </div>
      </div>

      <!-- 选项 -->
      <div class="prop-section" v-if="hasOptionProps">
        <div class="prop-section-title">选项</div>
        <div class="prop-row" v-if="'type' in control.props && (control.type === 'DatePicker' || control.type === 'DateRange')">
          <label>类型</label><select v-model="control.props.type" @change="save" class="prop-select"><option value="date">Date</option><option value="datetime">DateTime</option></select>
        </div>
        <div class="prop-row" v-if="'format' in control.props && control.type !== 'TimePicker'">
          <label>格式</label><select v-model="control.props.format" @change="save" class="prop-select"><option value="yyyy-MM-dd">yyyy-MM-dd</option><option value="yyyy-MM-dd HH:mm:ss">yyyy-MM-dd HH:mm:ss</option><option value="MM-dd-yyyy">MM-dd-yyyy</option></select>
        </div>
        <div class="prop-row" v-if="'format' in control.props && control.type === 'TimePicker'">
          <label>格式</label><select v-model="control.props.format" @change="save" class="prop-select"><option value="HH:mm:ss">HH:mm:ss</option><option value="HH:mm">HH:mm</option></select>
        </div>
        <div class="prop-row" v-if="'showTimeInterval' in control.props">
          <label>时间间隔</label><label class="prop-switch"><input type="checkbox" v-model="control.props.showTimeInterval" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="'direction' in control.props">
          <label>方向</label><select v-model="control.props.direction" @change="save" class="prop-select"><option value="horizontal">水平</option><option value="vertical">垂直</option></select>
        </div>
        <div class="prop-row" v-if="'actionType' in control.props">
          <label>动作</label><select v-model="control.props.actionType" @change="save" class="prop-select"><option value="">无</option><option value="submit">提交</option><option value="save">保存</option><option value="add">新增行</option><option value="delete">删除行</option></select>
        </div>
        <div class="prop-row" v-if="'size' in control.props">
          <label>尺寸</label><select v-model="control.props.size" @change="save" class="prop-select"><option value="small">小</option><option value="medium">中</option><option value="large">大</option></select>
        </div>
        <div class="prop-row" v-if="'align' in control.props">
          <label>对齐</label><select v-model="control.props.align" @change="save" class="prop-select"><option value="left">左</option><option value="center">中</option><option value="right">右</option></select>
        </div>
        <div class="prop-row" v-if="'color' in control.props">
          <label>颜色</label>
          <div style="display:flex;gap:4px;align-items:center;">
            <input type="color" v-model="control.props.color" @input="save" class="prop-color" style="width:36px;height:28px;padding:1px;border:1px solid #ccc;border-radius:3px;cursor:pointer;" />
            <input v-model="control.props.color" @input="save" class="prop-input" placeholder="#333333" style="flex:1;min-width:0;" />
            <button v-if="control.props.color" @click="control.props.color='';save()" style="padding:2px 8px;font-size:12px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;color:#666;">清除</button>
          </div>
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>背景色</label>
          <div style="display:flex;gap:4px;align-items:center;">
            <input type="color" v-model="control.props.backgroundColor" @input="save" class="prop-color" style="width:36px;height:28px;padding:1px;border:1px solid #ccc;border-radius:3px;cursor:pointer;" />
            <input v-model="control.props.backgroundColor" @input="save" class="prop-input" placeholder="如 #e0e7ff" style="flex:1;min-width:0;" />
            <button v-if="control.props.backgroundColor" @click="control.props.backgroundColor='';save()" style="padding:2px 8px;font-size:12px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;color:#666;">清除</button>
          </div>
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>圆角</label><input type="number" v-model.number="control.props.borderRadius" @input="save" class="prop-input" style="width:80px;" />
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>内边距</label><input type="number" v-model.number="control.props.padding" @input="save" class="prop-input" style="width:80px;" />
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>加粗</label><label class="prop-switch"><input type="checkbox" v-model="control.props.bold" @change="save" /><span class="slider"></span></label>
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>样式</label>
          <select v-model="control.props.labelStyle" @change="save" class="prop-select">
            <option value="">默认</option>
            <option value="header">标题头</option>
          </select>
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>行高</label><input type="number" v-model.number="control.props.lineHeight" @input="save" class="prop-input" style="width:80px;" placeholder="px" />
        </div>
        <div class="prop-row full" v-if="control.type === 'Label'">
          <label>阴影</label><input v-model="control.props.boxShadow" @input="save" class="prop-input" placeholder="如 20px 0px 0px #d1fae5" />
        </div>
        <div class="prop-row" v-if="control.type === 'Label'">
          <label>字间距</label><input type="number" v-model.number="control.props.letterSpacing" @input="save" class="prop-input" style="width:80px;" placeholder="px" />
        </div>
        <div class="prop-row" v-if="'target' in control.props">
          <label>打开</label><select v-model="control.props.target" @change="save" class="prop-select"><option value="_blank">新窗口</option><option value="_self">当前窗口</option></select>
        </div>
      </div>

      <!-- 公式 -->
      <div class="prop-section" v-if="'formula' in control.props">
        <div class="prop-section-title">公式</div>
        <div class="prop-row full"><label>公式</label><textarea v-model="control.props.formula" @input="save" class="prop-input" rows="2" placeholder="输入计算公式"></textarea></div>
      </div>

      <!-- 计算（Input/InputNumber/Money） -->
      <div class="prop-section" v-if="'total' in control.props || 'iscapital' in control.props || 'autobrowse' in control.props || 'ispercent' in control.props">
        <div class="prop-section-title">计算</div>
        <div class="prop-row full" v-if="'total' in control.props"><label>表达式</label><textarea v-model="control.props.total" @input="save" class="prop-input" rows="1" placeholder="如 SUM(field1,field2)"></textarea></div>
        <div class="prop-row" v-if="'ispercent' in control.props"><label>百分号</label><label class="prop-switch"><input type="checkbox" v-model="control.props.ispercent" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row" v-if="'iscapital' in control.props"><label>金额大写</label><label class="prop-switch"><input type="checkbox" v-model="control.props.iscapital" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row" v-if="'autobrowse' in control.props"><label>自动开窗</label><label class="prop-switch"><input type="checkbox" v-model="control.props.autobrowse" @change="save" /><span class="slider"></span></label></div>
        <!-- 自动开窗配置（Input 类型，autobrowse 开启时显示） -->
        <template v-if="control.type === 'Input' && control.props.autobrowse">
          <div class="col-sep">开窗配置</div>
          <div class="prop-row full"><label>绑定表</label><input v-model="control.props.browsebindtable" @input="onInputBrowseTableChange" class="prop-input" placeholder="查询的数据库表名" list="tableList" /><datalist id="tableList"><option v-for="t in tableNames" :key="t" :value="t">{{ t }}</option></datalist></div>
          <div class="prop-row full"><label>过滤条件</label><input v-model="control.props.browsefilter" @input="save" class="prop-input" placeholder="如 status=1 AND id=[FID]" /></div>
          <div class="prop-row full"><label>显示字段</label><input v-model="control.props.browseshowfields" @input="save" class="prop-input" placeholder="如 guid,name,code" /></div>
          <div class="prop-row full"><label>排序</label><input v-model="control.props.browseorderby" @input="save" class="prop-input" placeholder="如 orderCol ASC" /></div>
          <div class="prop-row full">
            <label>数据映射</label>
            <DataMapEditor v-model="control.props.datamapList" :sourceColumns="inputBrowseColumns" :targetTables="tableNames" />
          </div>
        </template>
      </div>

      <!-- 下拉选项绑定（Select） -->
      <div class="prop-section" v-if="'selectbindtable' in control.props && control.type !== 'TreeSelect'">
        <div class="prop-section-title">选项绑定</div>
        <div class="prop-row">
          <label>取值类型</label>
          <select v-model="control.props.sourceType" @change="save" class="prop-select">
            <option value="Options">选项</option>
            <option value="DataSource">数据来源</option>
          </select>
        </div>
        
        <!-- 选项模式 -->
        <div v-if="control.props.sourceType !== 'DataSource'">
          <div class="prop-row full"><label>选项</label><textarea v-model="control.props.options" @input="save" class="prop-input" rows="2" placeholder="选项1,选项2,选项3"></textarea></div>
        </div>
        
        <!-- 数据来源模式 -->
        <div v-if="control.props.sourceType === 'DataSource'">
          <div class="prop-row full">
            <label>绑定表</label>
            <div style="display:flex;gap:4px;">
              <input v-model="control.props.selectbindtable" @input="save" class="prop-input" placeholder="数据库表名或视图名" style="flex:1;" list="tableList" />
              <datalist id="tableList">
                <option v-for="t in tableNames" :key="t" :value="t">{{ t }}</option>
              </datalist>
              <button @click="loadTableNames" style="padding:4px 8px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;" title="加载表列表"><i class="fas fa-sync"></i></button>
            </div>
          </div>
          <div class="prop-row full">
            <label>值字段</label>
            <select v-model="control.props.selectvaluecolumn" @change="save" class="prop-select">
              <option value="">请选择</option>
              <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="prop-row full">
            <label>显示字段</label>
            <select v-model="control.props.selectdisplaycolumn" @change="save" class="prop-select">
              <option value="">请选择</option>
              <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>过滤条件</label><input v-model="control.props.selectfilter" @input="save" class="prop-input" placeholder="如 Status=@Id 或 Status=#name" /></div>
          <div class="prop-row full"><label>排序</label><input v-model="control.props.browseorderby" @input="save" class="prop-input" placeholder="如 sortOrder ASC" /></div>
        </div>
        
        <!-- 数据映射 -->
        <div class="prop-row full">
          <label>数据映射</label>
          <DataMapEditor 
            v-model="control.props.datamapList" 
            :sourceColumns="columnNames" 
            :targetTables="tableNames"
          />
        </div>
      </div>

      <!-- 树形选择绑定（TreeSelect） -->
      <div class="prop-section" v-if="control.type === 'TreeSelect'">
        <div class="prop-row full">
          <label>绑定表</label>
          <div style="display:flex;gap:4px;">
            <input v-model="control.props.selectbindtable" @input="onTreeTableChange" class="prop-input" placeholder="数据库表名或视图名" style="flex:1;" list="tableList" />
            <datalist id="tableList">
              <option v-for="t in tableNames" :key="t" :value="t">{{ t }}</option>
            </datalist>
            <button @click="loadTableNames" style="padding:4px 8px;cursor:pointer;border:1px solid #ccc;border-radius:3px;background:#fff;" title="加载表列表"><i class="fas fa-sync"></i></button>
          </div>
        </div>
        <div class="prop-row full">
          <label>值字段</label>
          <select v-model="control.props.selectvaluecolumn" @change="save" class="prop-select">
            <option value="">请选择</option>
            <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
          </select>
        </div>
        <div class="prop-row full">
          <label>显示字段</label>
          <select v-model="control.props.selectdisplaycolumn" @change="save" class="prop-select">
            <option value="">请选择</option>
            <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
          </select>
        </div>
        
        <!-- 树形结构配置 -->
        <div class="col-sep">树形结构</div>
        <div class="prop-row full">
          <label>ID字段</label>
          <select v-model="control.props.treeIdField" @change="save" class="prop-select">
            <option value="">请选择</option>
            <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
          </select>
        </div>
        <div class="prop-row full">
          <label>父ID字段</label>
          <select v-model="control.props.treeParentIdField" @change="save" class="prop-select">
            <option value="">请选择</option>
            <option v-for="c in columnNames" :key="c" :value="c">{{ c }}</option>
          </select>
        </div>
        <div class="prop-row full">
          <label>根节点值</label>
          <input v-model="control.props.treeRootValue" @input="save" class="prop-input" placeholder="如 0 或空字符串" />
        </div>
        
        <div class="prop-row full"><label>过滤条件</label><input v-model="control.props.selectfilter" @input="save" class="prop-input" placeholder="如 Status=@Id 或 Status=#name" /></div>
        <div class="prop-row full"><label>排序</label><input v-model="control.props.browseorderby" @input="save" class="prop-input" placeholder="如 sortOrder ASC" /></div>
        
        <!-- 数据映射 -->
        <div class="prop-row full">
          <label>数据映射</label>
          <DataMapEditor 
            v-model="control.props.datamapList" 
            :sourceColumns="columnNames" 
            :targetTables="tableNames"
          />
        </div>
      </div>

      <!-- Checkbox类型 -->
      <div class="prop-section" v-if="'detailck' in control.props">
        <div class="prop-section-title">复选类型</div>
        <div class="prop-row"><label>类型</label><select v-model="control.props.detailck" @change="save" class="prop-select"><option value="Default">默认</option><option value="GridCheck">列表全选</option><option value="GridCheckAll">全选/反选</option></select></div>
      </div>

      <!-- HyperLink类型 -->
      <div class="prop-section" v-if="'linktype' in control.props">
        <div class="prop-section-title">链接设置</div>
        <div class="prop-row"><label>类型</label><select v-model="control.props.linktype" @change="save" class="prop-select"><option value="Default">默认链接</option></select></div>
      </div>

      <!-- 附件设置（FileUpload） -->
      <div class="prop-section" v-if="'attachmenttype' in control.props">
        <div class="prop-section-title">附件设置</div>
        <div class="prop-row"><label>类型</label><select v-model="control.props.attachmenttype" @change="save" class="prop-select"><option value="Upload">上传</option><option value="View">查看</option></select></div>
        <div class="prop-row"><label>保存附件表</label><label class="prop-switch"><input type="checkbox" v-model="control.props.savetotable" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row"><label>必须上传</label><label class="prop-switch"><input type="checkbox" v-model="control.props.isupload" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row"><label>可删除</label><label class="prop-switch"><input type="checkbox" v-model="control.props.isdelete" @change="save" /><span class="slider"></span></label></div>
      </div>

      <!-- 图片设置（ImageUpload） -->
      <div class="prop-section" v-if="control.type === 'ImageUpload' && ('isupload' in control.props)">
        <div class="prop-section-title">图片设置</div>
        <div class="prop-row"><label>必须上传</label><label class="prop-switch"><input type="checkbox" v-model="control.props.isupload" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row"><label>可删除</label><label class="prop-switch"><input type="checkbox" v-model="control.props.isdelete" @change="save" /><span class="slider"></span></label></div>
      </div>

      <!-- 子表设置 -->
      <div class="prop-section" v-if="control.type === 'SubTable' && ('align' in control.props)">
        <div class="prop-section-title">子表设置</div>
        <div class="prop-row"><label>对齐</label><select v-model="control.props.align" @change="save" class="prop-select"><option value="left">左对齐</option><option value="center">居中</option><option value="right">右对齐</option></select></div>
        <div class="prop-row"><label>子表标识</label><label class="prop-switch"><input type="checkbox" v-model="control.props.formgrid" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row"><label>不允许空</label><label class="prop-switch"><input type="checkbox" v-model="control.props.needrow" @change="save" /><span class="slider"></span></label></div>
        <div class="prop-row full"><label>数据源表</label><input v-model="control.props.formbindtable" @input="save" class="prop-input" placeholder="子表绑定的数据库表" /></div>
      </div>

      <!-- 按钮浏览（Button） -->
      <div class="prop-section" v-if="'buttontype' in control.props">
        <div class="prop-section-title">按钮功能</div>
        <div class="prop-row"><label>按钮类型</label><select v-model="control.props.buttontype" @change="onButtonTypeChange" class="prop-select"><option value="">默认</option><option value="Add">新增</option><option value="Delete">删除</option><option value="MoveUp">上移</option><option value="MoveDown">下移</option><option value="MoveToTop">置顶</option><option value="MoveToBottom">置底</option><option value="Browse">浏览</option><option value="BrowseCustom">自定义浏览</option><option value="CopyRow">复制行</option></select></div>
        <template v-if="control.props.buttontype === 'Browse' || control.props.buttontype === 'BrowseCustom'">
          <div class="prop-row"><label>浏览模式</label><select v-model="control.props.mode" @change="save" class="prop-select"><option value="Single">单选</option><option value="Multiple">多选</option><option value="MultipleSelect">多选返回</option></select></div>
          <div class="prop-row full"><label>数据源</label>
            <select v-model="control.props.browsedatasource" @change="save" class="prop-select">
              <option value="">-- 选择表 --</option>
              <option v-for="t in buttonBrowseTables" :key="t.guid || t.Guid" :value="t.tableName || t.TableName">{{ t.tableName || t.TableName }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>绑定表</label>
            <select v-model="control.props.browsebindtable" @change="onButtonBindTableChange" class="prop-select">
              <option value="">-- 选择表 --</option>
              <option v-for="t in buttonBrowseTables" :key="t.guid || t.Guid" :value="t.tableName || t.TableName">{{ t.tableName || t.TableName }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>显示字段</label>
            <select v-model="control.props.browseshowfields" @change="save" class="prop-select">
              <option value="">-- 选择字段 --</option>
              <option v-for="col in buttonBrowseColumns" :key="col.columnName || col.ColumnName" :value="col.columnName || col.ColumnName">{{ col.columnName || col.ColumnName }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>过滤条件</label><input v-model="control.props.browsefilter" @input="save" class="prop-input" placeholder="如 status=1" /></div>
          <div class="prop-row full"><label>排序</label><input v-model="control.props.browseorderby" @input="save" class="prop-input" placeholder="如 sortOrder ASC" /></div>
          <div class="prop-row full" v-if="control.props.buttontype === 'BrowseCustom'"><label>自定义URL</label><input v-model="control.props.browseurl" @input="save" class="prop-input" placeholder="自定义浏览地址" /></div>
          <div class="prop-row full"><label>数据映射</label><DataMapEditor v-model="control.props.datamapList" :sourceColumns="buttonBrowseColumns" :targetTables="tableNames" /></div>
          <div class="prop-row"><label>多行返回</label><label class="prop-switch"><input type="checkbox" v-model="control.props.morerow" @change="save" /><span class="slider"></span></label></div>
          <div class="prop-row"><label>不回填</label><label class="prop-switch"><input type="checkbox" v-model="control.props.notarget" @change="save" /><span class="slider"></span></label></div>
        </template>
        <div class="prop-row" v-if="control.props.buttontype === 'Add'"><label>复制行</label><label class="prop-switch"><input type="checkbox" v-model="control.props.copyrow" @change="save" /><span class="slider"></span></label></div>
      </div>

      <!-- 权限 -->
      <div class="prop-section" v-if="hasPermissions">
        <div class="prop-section-title">权限</div>
        <!-- 可见角色 -->
        <div class="prop-row full"><label>可见角色</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('visibleRoles')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('visibleRoles', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('visibleRoles','role')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
        <!-- 可见用户 -->
        <div class="prop-row full"><label>可见用户</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('visibleUsers')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('visibleUsers', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('visibleUsers','user')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
        <!-- 可见组织 -->
        <div class="prop-row full"><label>可见组织</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('visibleOrgs')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('visibleOrgs', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('visibleOrgs','dept')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
        <!-- 可编辑角色 -->
        <div class="prop-row full"><label>可编角色</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('editableRoles')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('editableRoles', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('editableRoles','role')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
        <!-- 可编辑用户 -->
        <div class="prop-row full"><label>可编用户</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('editableUsers')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('editableUsers', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('editableUsers','user')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
        <!-- 可编辑组织 -->
        <div class="prop-row full"><label>可编组织</label>
          <div class="perm-tags">
            <span v-for="item in getSelectedItems('editableOrgs')" :key="item.id" class="perm-tag">{{ item.name }}<i class="fas fa-times" @click="removePermItem('editableOrgs', item.id)"></i></span>
            <button class="perm-select-btn" @click="openPermPicker('editableOrgs','dept')"><i class="fas fa-plus"></i> 选择</button>
          </div>
        </div>
      </div>

      <!-- HandlerPicker 弹窗 -->
      <HandlerPicker
        :visible="permPicker.visible"
        :mode="permPicker.mode"
        :title="permPicker.title"
        @close="permPicker.visible = false"
        @pick="onHandlerPick"
      />

      <!-- 事件 -->
      <div class="prop-section" v-if="hasEvents">
        <div class="prop-section-title">事件</div>
        <div class="prop-row full"><label>值变化</label><textarea v-model="control.props.onChange" @input="save" class="prop-input" rows="1" placeholder="onChange事件"></textarea></div>
        <div class="prop-row full"><label>获焦点</label><textarea v-model="control.props.onFocus" @input="save" class="prop-input" rows="1" placeholder="onFocus事件"></textarea></div>
        <div class="prop-row full"><label>失焦点</label><textarea v-model="control.props.onBlur" @input="save" class="prop-input" rows="1" placeholder="onBlur事件"></textarea></div>
        <div class="prop-row full"><label>点击</label><textarea v-model="control.props.onClick" @input="save" class="prop-input" rows="1" placeholder="onClick事件"></textarea></div>
      </div>

      <div class="prop-actions">
        <button class="btn-copy" @click="$emit('duplicate', control.id)"><i class="fas fa-copy"></i> 复制</button>
        <button class="btn-del" @click="$emit('delete', control.id)"><i class="fas fa-trash"></i> 删除</button>
      </div>
    </div>
    <div class="prop-empty" v-else>
      <i class="fas fa-hand-pointer"></i>
      <p>点击画布中的控件查看属性</p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, reactive, onMounted } from 'vue'
import { getDbTables, getTableColumns, getDatabaseTables } from '../../../api/process'
import { getRoleTree } from '../../../api/role'
import { getOrgTree } from '../../../api/org'
import { getUserList } from '../../../api/user'
import HandlerPicker from '../../../components/HandlerPicker.vue'
import DataMapEditor from '../../../components/DataMapEditor.vue'

const props = defineProps({ control: { type: Object, default: null } })
const emit = defineEmits(['update', 'delete', 'duplicate'])
const isTableType = computed(() => props.control && ['SubTable'].includes(props.control.type))
const isTextType = computed(() => props.control && ['Input', 'Textarea'].includes(props.control.type))
const hasFieldId = computed(() => props.control && ['fieldId','fieldName','className'].some(k => k in props.control.props))
const hasBase = computed(() => props.control && ['label','placeholder','content','options','href','text','prefix','length','title','startPlaceholder','endPlaceholder'].some(k => k in props.control.props))
const hasDataBinding = computed(() => props.control && ['dataSourceTable','dataSourceField','dataTargetTable','dataTargetField','dataSource','dataTarget','defaultValue'].some(k => k in props.control.props))
const hasSizeProps = computed(() => props.control && ['width','height','rows','padding','gap','fontSize','fileMaxSize','fileMaxCount'].some(k => k in props.control.props))
const hasNumberProps = computed(() => props.control && ['min','max','decimal','separator'].some(k => k in props.control.props))
const hasValidate = computed(() => props.control && ['required','maxLength','minLength','regex','regexMsg'].some(k => k in props.control.props))
const hasStatus = computed(() => props.control && ['readonly','disabled','hidden','printHide','multiple'].some(k => k in props.control.props))
const hasSubTableProps = computed(() => props.control && props.control.type === 'SubTable')
const hasSubTableCols = computed(() => props.control && props.control.type === 'SubTable')
const selectedColIndex = ref(-1)

// ===== Select 数据来源：表名/列名加载 =====
const tableNames = ref([])
const columnNames = ref([])
const inputBrowseColumns = ref([])
const subColColumnsMap = reactive({}) // 每列的绑定字段列表缓存

async function loadTableNames() {
  try {
    const res = await getDatabaseTables()
    const list = res.data || res.Data || res || []
    tableNames.value = Array.isArray(list) ? list.map(t => typeof t === 'object' ? (t.name || t.table_name || t.TableName || t.TABLE_NAME || JSON.stringify(t)) : String(t)) : []
  } catch (e) {
    console.warn('加载表列表失败:', e)
  }
}

// 监听绑定表变化，自动加载列（Select / TreeSelect 共用）
watch(
  () => props.control?.props?.selectbindtable,
  async (newVal) => {
    if (newVal && (props.control?.type === 'Select' || props.control?.type === 'TreeSelect')) {
      try {
        const res = await getTableColumns(newVal)
        const list = res.data || res.Data || res || []
        columnNames.value = Array.isArray(list) ? list.map(c => typeof c === 'object' ? (c.name || c.column_name || c.ColumnName || c.COLUMN_NAME || JSON.stringify(c)) : String(c)) : []
      } catch (e) {
        console.warn('加载列失败:', e)
        columnNames.value = []
      }
    } else {
      columnNames.value = []
    }
  }
)

// TreeSelect 绑定表变化（@input 时手动触发加载列）
async function onTreeTableChange() {
  const tbl = props.control?.props?.selectbindtable
  if (tbl) {
    try {
      const res = await getTableColumns(tbl)
      const list = res.data || res.Data || res || []
      columnNames.value = Array.isArray(list) ? list.map(c => typeof c === 'object' ? (c.name || c.column_name || c.ColumnName || c.COLUMN_NAME || JSON.stringify(c)) : String(c)) : []
    } catch (e) {
      console.warn('加载列失败:', e)
      columnNames.value = []
    }
  } else {
    columnNames.value = []
  }
  save()
}

// ===== 按钮浏览：表/列加载 =====
const buttonBrowseTables = ref([])
const buttonBrowseColumns = ref([])

async function loadButtonBrowseTables() {
  try {
    const res = await getDatabaseTables()
    const list = res.data || res.Data || res || []
    buttonBrowseTables.value = Array.isArray(list) ? list.map(t => {
      if (typeof t === 'object') {
        return { tableName: t.name || t.table_name || t.TableName || t.TABLE_NAME || '', guid: t.guid || t.Guid || '' }
      }
      return { tableName: String(t), guid: '' }
    }) : []
  } catch (e) {
    console.warn('加载表列表失败:', e)
  }
}

async function onButtonBindTableChange() {
  const tbl = props.control?.props?.browsebindtable
  if (tbl) {
    try {
      const res = await getTableColumns(tbl)
      const list = res.data || res.Data || res || []
      buttonBrowseColumns.value = Array.isArray(list) ? list.map(c => {
        if (typeof c === 'object') {
          return { columnName: c.name || c.column_name || c.ColumnName || c.COLUMN_NAME || '' }
        }
        return { columnName: String(c) }
      }) : []
    } catch (e) {
      console.warn('加载列失败:', e)
      buttonBrowseColumns.value = []
    }
  } else {
    buttonBrowseColumns.value = []
  }
  save()
}

function onButtonTypeChange() {
  const bt = props.control?.props?.buttontype
  if ((bt === 'Browse' || bt === 'BrowseCustom') && buttonBrowseTables.value.length === 0) {
    loadButtonBrowseTables()
  }
  save()
}

// Input 开窗：绑定表变化时加载源字段列
async function onInputBrowseTableChange() {
  const tbl = props.control?.props?.browsebindtable
  if (tbl) {
    try {
      const res = await getTableColumns(tbl)
      const list = res.data || res.Data || res || []
      inputBrowseColumns.value = Array.isArray(list) ? list.map(c => typeof c === 'object' ? (c.name || c.column_name || c.ColumnName || c.COLUMN_NAME || '') : String(c)) : []
    } catch (e) {
      console.warn('加载列失败:', e)
      inputBrowseColumns.value = []
    }
  } else {
    inputBrowseColumns.value = []
  }
  save()
}

// 子表列管理
function addSubColumn() {
  if (!props.control || props.control.type !== 'SubTable') return
  if (!props.control.props.columns) props.control.props.columns = []
  props.control.props.columns.push({
    id: 'col_' + Date.now(),
    type: 'Input',
    props: {
      label: '列' + (props.control.props.columns.length + 1),
      bindTable: '',
      dataSourceField: '',
      placeholder: '',
      defaultValue: '',
      required: false,
      readonly: false,
      maxLength: null
    }
  })
  selectedColIndex.value = props.control.props.columns.length - 1
  save()
}

function addOperationColumn() {
  if (!props.control || props.control.type !== 'SubTable') return
  if (!props.control.props.columns) props.control.props.columns = []
  props.control.props.columns.push({
    id: 'col_' + Date.now(),
    type: '_operation',
    props: {
      label: '操作',
      width: 120,
      operationType: 'add-delete'
    }
  })
  selectedColIndex.value = props.control.props.columns.length - 1
  save()
}

function removeSubColumn(index) {
  if (!props.control || !props.control.props.columns) return
  props.control.props.columns.splice(index, 1)
  delete subColColumnsMap[index]
  if (selectedColIndex.value >= props.control.props.columns.length) {
    selectedColIndex.value = props.control.props.columns.length - 1
  }
  save()
}

// 子表绑定表变化 → 加载该表的字段
async function onSubTableBindTableChange() {
  save()
}

// 子表某列绑定表变化 → 加载该表的字段供下拉选择
async function onSubColBindTableChange(colIndex) {
  save()
  const col = props.control?.props?.columns?.[colIndex]
  if (!col) return
  const tableName = col.props?.bindTable
  if (!tableName) {
    subColColumnsMap[colIndex] = []
    return
  }
  try {
    const res = await getTableColumns(tableName)
    const list = res.data || res.Data || res || []
    subColColumnsMap[colIndex] = Array.isArray(list) ? list.map(c => typeof c === 'object' ? (c.name || c.column_name || c.ColumnName || c.COLUMN_NAME || JSON.stringify(c)) : String(c)) : []
  } catch (e) {
    console.warn('加载子表列字段失败:', e)
    subColColumnsMap[colIndex] = []
  }
}

// 选中列时，如果该列有bindTable则加载字段列表
watch(
  () => selectedColIndex.value,
  async (newIndex) => {
    const col = props.control?.props?.columns?.[newIndex]
    if (col && col.type !== '_operation' && col.props?.bindTable && !subColColumnsMap[newIndex]) {
      await onSubColBindTableChange(newIndex)
    }
  }
)

const hasOptionProps = computed(() => props.control && ['type','format','direction','actionType','size','align','color','target','showTimeInterval'].some(k => k in props.control.props))
const hasPermissions = computed(() => props.control && ['visibleRoles','visibleUsers','visibleOrgs','editableRoles','editableUsers','editableOrgs'].some(k => k in props.control.props))
const hasEvents = computed(() => props.control && ['onChange','onFocus','onBlur','onClick'].some(k => k in props.control.props))
function save() { emit('update') }

// 系统变量选择：选中后把变量占位符写入 defaultValue
const sysVarPlaceholders = {
  'syscurrentdatetime': '${syscurrentdatetime}',
  'syscurrenttime': '${syscurrenttime}',
  'systoday': '${systoday}',
  'systaskid': '${systaskid}',
  'sysloginuser.account': '${sysloginuser.account}',
  'sysloginuser.displayname': '${sysloginuser.displayname}',
  'sysloginuser.email': '${sysloginuser.email}',
  'sysloginuser.tel': '${sysloginuser.tel}',
  'sysloginuser.mb': '${sysloginuser.mb}',
  'sysloginuser.hrid': '${sysloginuser.hrid}',
  'sysloginuser.job': '${sysloginuser.job}',
  'sysloginuser.office': '${sysloginuser.office}',
  'sysloginuser.costcenter': '${sysloginuser.costcenter}',
  'sysloginuser.levels': '${sysloginuser.levels}',
  'sysloginuser.description': '${sysloginuser.description}',
  'sysloginuser.birthday': '${sysloginuser.birthday}',
  'sysloginuser.joindate': '${sysloginuser.joindate}',
  'sysloginuser.qq': '${sysloginuser.qq}',
}
function onSysVarChange() {
  if (!props.control || !props.control.props) return
  const v = props.control.props.defaultValueSysVar
  if (v && sysVarPlaceholders[v]) {
    props.control.props.defaultValue = sysVarPlaceholders[v]
  }
  save()
}

// ===== 权限选择器 =====
const allNamesMap = reactive({})

const permPicker = reactive({
  visible: false,
  mode: 'dept',
  title: '',
  targetField: ''
})

// 预加载所有数据以填充 allNamesMap（供标签显示名称使用）
async function loadRoleTree() {
  try {
    const res = await getRoleTree()
    const list = res.data || res.Data || []
    const nodes = (Array.isArray(list) ? list : []).map(mapRoleNode)
    collectNames(nodes)
  } catch (e) { /* ignore */ }
}

async function loadOrgTree() {
  try {
    const res = await getOrgTree()
    const list = res.data || res.Data || []
    const nodes = (Array.isArray(list) ? list : []).map(mapOrgNode)
    collectNames(nodes)
  } catch (e) { /* ignore */ }
}

async function loadUserNodes() {
  try {
    const res = await getUserList()
    const list = res.data || res.Data || []
    const arr = Array.isArray(list) ? list : (list?.data || [])
    arr.forEach(u => {
      const id = u.guid ?? u.Guid ?? ''
      const name = u.displayName ?? u.DisplayName ?? u.account ?? u.Account ?? ''
      allNamesMap[id] = name
    })
  } catch (e) { /* ignore */ }
}

function mapRoleNode(n) {
  const id = n.guid ?? n.Guid ?? ''
  const name = n.roleName ?? n.RoleName ?? n.sName ?? n.SName ?? ''
  allNamesMap[id] = name
  return { id, name, children: (n.children || n.Children || []).map(mapRoleNode) }
}

function mapOrgNode(n) {
  const id = n.guid ?? n.Guid ?? ''
  const name = n.ousName ?? n.oUsName ?? n.OUsName ?? n.name ?? n.Name ?? ''
  allNamesMap[id] = name
  return { id, name, children: (n.children || n.Children || []).map(mapOrgNode) }
}

function collectNames(nodes) {
  for (const n of nodes) {
    allNamesMap[n.id] = n.name
    if (n.children && n.children.length) collectNames(n.children)
  }
}

// 解析逗号分隔的 ID 字符串，返回 { id, name } 数组
function parseIds(key) {
  const raw = props.control?.props?.[key]
  if (!raw) return []
  return String(raw).split(',').filter(Boolean).map(id => ({
    id: id.trim(),
    name: allNamesMap[id.trim()] || id.trim()
  }))
}

function getSelectedItems(key) {
  return parseIds(key)
}

function removePermItem(field, id) {
  const raw = props.control.props[field] || ''
  const ids = raw.split(',').filter(Boolean).map(s => s.trim())
  const idx = ids.indexOf(id)
  if (idx >= 0) ids.splice(idx, 1)
  props.control.props[field] = ids.join(',')
  save()
}

function openPermPicker(field, mode) {
  permPicker.targetField = field
  permPicker.mode = mode
  permPicker.title = mode === 'dept' ? '选择部门' : mode === 'role' ? '选择角色' : '选择人员'
  permPicker.visible = true
}

function onHandlerPick(result) {
  const raw = props.control.props[permPicker.targetField] || ''
  const ids = raw ? raw.split(',').filter(Boolean).map(s => s.trim()) : []
  const newId = result.id
  if (!ids.includes(newId)) {
    ids.push(newId)
    if (!allNamesMap[newId]) allNamesMap[newId] = result.name
    props.control.props[permPicker.targetField] = ids.join(',')
    save()
  }
}

// ===== 表绑定下拉 =====
const boundTables = ref([])
const srcColumns = ref([])
const tgtColumns = ref([])

const flowGuid = computed(() => window.currentEditingProcess?.guid || '')

async function loadBoundTables() {
  if (!flowGuid.value) return
  try {
    const res = await getDbTables(flowGuid.value)
    const data = res.data || res.Data || res || []
    boundTables.value = Array.isArray(data) ? data : []
  } catch (e) {
    boundTables.value = []
  }
}

async function loadColumnsForTable(tableName) {
  if (!tableName) return []
  try {
    const res = await getTableColumns(tableName)
    const data = res.data || res.Data || res || []
    return Array.isArray(data) ? data : []
  } catch (e) {
    return []
  }
}

watch(() => props.control?.id, async (newId, oldId) => {
  selectedColIndex.value = -1
  if (newId && hasDataBinding.value) {
    await loadBoundTables()
    if (props.control.props.dataSourceTable) {
      srcColumns.value = await loadColumnsForTable(props.control.props.dataSourceTable)
    } else { srcColumns.value = [] }
    if (props.control.props.dataTargetTable) {
      tgtColumns.value = await loadColumnsForTable(props.control.props.dataTargetTable)
    } else { tgtColumns.value = [] }
  }
}, { immediate: true })

const onSrcTableChange = async (e) => {
  const tableName = e.target.value
  props.control.props.dataSourceTable = tableName
  props.control.props.dataSourceField = ''
  srcColumns.value = await loadColumnsForTable(tableName)
  save()
}

const onSrcFieldChange = (e) => {
  props.control.props.dataSourceField = e.target.value
  save()
}

const onTgtTableChange = async (e) => {
  const tableName = e.target.value
  props.control.props.dataTargetTable = tableName
  props.control.props.dataTargetField = ''
  tgtColumns.value = await loadColumnsForTable(tableName)
  save()
}

const onTgtFieldChange = (e) => {
  props.control.props.dataTargetField = e.target.value
  // Auto-derive maxLength from database column definition for character types
  if (props.control.type === 'Input' || props.control.type === 'Textarea' || props.control.type === 'RichText') {
    if (e.target.value) {
      const col = tgtColumns.value.find(c => (c.columnName || c.ColumnName) === e.target.value)
      if (col) {
        const colType = (col.dataType || col.DataType || col.columnType || '').toLowerCase()
        const match = colType.match(/^(?:n?varchar|char|nchar|text|ntext)\s*\(\s*(\d+)\s*\)/i)
        if (match) {
          const len = parseInt(match[1])
          props.control.props.maxLength = len
          props.control.props._maxLengthAuto = true
        } else {
          if (props.control.props._maxLengthAuto) {
            props.control.props.maxLength = null
            props.control.props._maxLengthAuto = false
          }
        }
      }
    } else {
      if (props.control.props._maxLengthAuto) {
        props.control.props.maxLength = null
        props.control.props._maxLengthAuto = false
      }
    }
  }
  save()
}

onMounted(() => {
  loadRoleTree()
  loadOrgTree()
  loadUserNodes()
})
</script>

<style scoped>
.property-panel { width: 300px; background: #fff; border-left: 1px solid #e5e7eb; display: flex; flex-direction: column; height: 100%; flex-shrink: 0; }
.prop-header { padding: 10px 12px; border-bottom: 1px solid #e5e7eb; font-size: 13px; font-weight: 600; color: #374151; display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.prop-header i { color: #10b981; }
.prop-body { flex: 1; overflow-y: auto; }
.prop-section { padding: 0 12px; margin-bottom: 6px; }
.prop-section-title { font-size: 10px; font-weight: 600; color: #059669; padding: 6px 0 3px; border-bottom: 1px solid #ecfdf5; margin-bottom: 4px; }
.prop-row { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; }
.prop-row.full { flex-direction: column; align-items: stretch; }
.prop-row > label:first-child { font-size: 11px; color: #6b7280; width: 48px; flex-shrink: 0; text-align: right; }
.prop-row.full > label:first-child { width: auto; text-align: left; }
.prop-input, .prop-select { flex: 1; border: 1px solid #e5e7eb; border-radius: 3px; padding: 4px 6px; font-size: 11px; outline: none; }
.prop-input:focus, .prop-select:focus { border-color: #10b981; }
.prop-row.full .prop-input { flex: none; width: 100%; }
.bind-pair { display: flex; gap: 4px; flex: 1; }
.bind-pair .prop-select { flex: 1; min-width: 0; }
textarea.prop-input { resize: vertical; min-height: 22px; }
.unit { font-size: 10px; color: #9ca3af; margin-left: 4px; }
.colspan-bar { display: flex; gap: 1px; flex: 1; }
.cs-btn { flex: 1; padding: 2px 0; border: 1px solid #e5e7eb; border-radius: 2px; background: #fff; font-size: 10px; color: #6b7280; cursor: pointer; text-align: center; }
.cs-btn:hover { border-color: #10b981; color: #10b981; }
.cs-btn.active { background: #10b981; color: #fff; border-color: #10b981; }
.prop-switch { position: relative; width: 32px; height: 18px; flex-shrink: 0; }
.prop-switch input { display: none; }
.prop-switch .slider { position: absolute; inset: 0; background: #d1d5db; border-radius: 9px; cursor: pointer; transition: 0.2s; }
.prop-switch .slider::after { content: ''; position: absolute; top: 1px; left: 1px; width: 16px; height: 16px; background: #fff; border-radius: 50%; transition: 0.2s; }
.prop-switch input:checked + .slider { background: #10b981; }
.prop-switch input:checked + .slider::after { left: 14px; }
/* 子表列编辑 */
.col-sep { font-size: 11px; color: #6b7280; font-weight: 500; padding: 6px 0 4px 0; border-top: 1px dashed #e5e7eb; margin-top: 6px; }
.col-add-btn { background: #10b981; color: #fff; border: none; border-radius: 3px; width: 20px; height: 20px; cursor: pointer; font-size: 10px; display: flex; align-items: center; justify-content: center; }
.col-add-btn:hover { background: #059669; }
.col-empty { font-size: 11px; color: #9ca3af; padding: 8px 0; text-align: center; }
.col-list { display: flex; flex-direction: column; gap: 3px; margin-bottom: 6px; max-height: 160px; overflow-y: auto; }
.col-item { display: flex; align-items: center; gap: 4px; padding: 5px 8px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 4px; cursor: pointer; font-size: 11px; transition: all 0.15s; }
.col-item:hover { border-color: #10b981; background: #ecfdf5; }
.col-item.active { border-color: #10b981; background: #ecfdf5; }
.col-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #374151; }
.col-type-tag { background: #e0e7ff; color: #4f46e5; font-size: 9px; padding: 1px 5px; border-radius: 2px; flex-shrink: 0; }
.col-del-btn { background: none; border: none; color: #ef4444; cursor: pointer; font-size: 10px; padding: 2px; opacity: 0.5; transition: opacity 0.15s; }
.col-del-btn:hover { opacity: 1; }
.col-edit { border-top: 1px dashed #d1d5db; padding-top: 6px; margin-top: 4px; }
.prop-actions { padding: 10px 12px; display: flex; gap: 6px; border-top: 1px solid #f3f4f6; flex-shrink: 0; }
.btn-copy, .btn-del { flex: 1; padding: 5px 0; border-radius: 3px; border: 1px solid #e5e7eb; font-size: 11px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 4px; background: #fff; }
.btn-copy:hover { background: #ecfdf5; border-color: #10b981; color: #10b981; }
.btn-del:hover { background: #fef2f2; border-color: #ef4444; color: #ef4444; }
.prop-empty { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #9ca3af; font-size: 12px; gap: 6px; }
.prop-empty i { font-size: 28px; opacity: 0.4; }
/* 权限选择 */
.perm-tags { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }
.perm-tag { display: inline-flex; align-items: center; gap: 3px; background: #ecfdf5; color: #059669; font-size: 11px; padding: 1px 6px; border-radius: 3px; }
.perm-tag i { font-size: 9px; cursor: pointer; opacity: 0.6; }
.perm-tag i:hover { opacity: 1; color: #ef4444; }
.perm-select-btn { display: inline-flex; align-items: center; gap: 3px; background: #fff; border: 1px dashed #d1d5db; border-radius: 3px; padding: 2px 8px; font-size: 11px; color: #6b7280; cursor: pointer; white-space: nowrap; }
.perm-select-btn:hover { border-color: #10b981; color: #10b981; }
.perm-select-btn i { font-size: 9px; }
.auto-hint { display: inline-block; background: #dbeafe; color: #2563eb; font-size: 9px; padding: 1px 4px; border-radius: 2px; margin-left: 4px; cursor: help; }
</style>
